export default __webpack_public_path__ + "static/media/friendly04.6855f6c9.png";